import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Overlay, Tooltip } from 'react-bootstrap';

import exportWithBoundary from '../helpers/exportWithBoundary';

function TooltipWrap(props) {
  const {
    tipText,
    children,
    className,
    placement,
    tooltipClassName,
    popperConfig,
  } = props;
  const [showTooltip, setShowTooltip] = useState(false);

  const onBodyClick = () => {
    setShowTooltip(false);
  };

  const itemRef = useRef(null);

  useEffect(() => {
    document.body.addEventListener('click', onBodyClick);
    return () => {
      document.body.removeEventListener('click', onBodyClick);
    };
  }, []);

  return (
    <>
      <span
        className={className}
        ref={itemRef}
        onMouseEnter={() => {
          setShowTooltip(true);
        }}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {children}
      </span>
      <Overlay
        popperConfig={popperConfig}
        target={itemRef.current}
        show={tipText && showTooltip}
        placement={placement}
      >
        <Tooltip className={tooltipClassName}>{tipText}</Tooltip>
      </Overlay>
    </>
  );
}

TooltipWrap.defaultProps = {
  placement: 'bottom',
  className: '',
  tooltipClassName: '',
  popperConfig: {},
};

TooltipWrap.propTypes = {
  tipText: PropTypes.node.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  placement: PropTypes.string,
  popperConfig: PropTypes.shape({}),
  className: PropTypes.string,
  tooltipClassName: PropTypes.string,
};

// eslint-disable-next-line react/prop-types
function TooltipWrapFallback({ children }) {
  return <>{children || []}</>;
}

export default exportWithBoundary(TooltipWrap, TooltipWrapFallback);
